module.exports = {"title":"关于我","layout":"page","path":"/about","body":"<ul>\n<li>\n<p>某校大三在校学生一枚</p>\n</li>\n<li>\n<p>平时爱逛GitHub、打打篮球以及看看美剧</p>\n</li>\n<li>\n<p>最近比较钟情于React 和 Meteor</p>\n</li>\n<li>\n<p><em>另寻暑假实习～</em></p>\n</li>\n<li>\n<p><em><a href=\"https://shinyleee.github.io/resume/\" target=\"_blank\">我的简历</a></em></p>\n</li>\n</ul>\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/about/index.md
// module id = 516
// module chunks = 0